import { render, staticRenderFns } from "./MenubarTeam.vue?vue&type=template&id=852feefa&"
import script from "./MenubarTeam.vue?vue&type=script&lang=js&"
export * from "./MenubarTeam.vue?vue&type=script&lang=js&"
import style0 from "./MenubarTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports